import React, { Component } from 'react';
import { GenericEditPanel, GenericInputValidate } from 'com-gyf-webcore-userinterfacecomponents';

class LimiteDefectoTarjeta extends Component {
    constructor(props) {
        super(props)

        this.actualizarNovedadEstado = this.actualizarNovedadEstado.bind(this);
        this.changeInput = this.changeInput.bind(this);
    }
    /**
     * 
     * @param {any} novedad
     * @param {any} estadoId
     * @param {any} entidadId
     */
    actualizarNovedadEstado(novedad, estadoId, entidadId) {
        this.props.actualizarNovedadEstado(novedad.Id, estadoId, this.props.codigoNovedad, novedad.NovedadTipoId, entidadId)
    }
    /**
     * 
     * @param {any} event
     */
    changeInput(event) {
        this.props.changeInput(1, this.props.codigoNovedad, event.target.value)
    }
    /**
     * 
     */
    render() {
        let me = this;
        let errors;
        const { getFieldProps, getFieldError } = this.props.form;
        let errorContainer;
        let props = this.props;
        let seEstaEditando = props.dataCompleto.seEstaEditando;

        errorContainer = <label className="error">
            {(errors = getFieldError('limiteDefectoTarjeta')) ? errors.join(',') : null}</label>

        let error = (getFieldError('limiteDefectoTarjeta')) ? true : false;

        //////////Novedad en límite por defecto de tarjeta////////////
        let descripcion = props.data.LimiteDefaultTarjetas;
        let novedadLimiteDefectoTarjeta = undefined;
        if (props.dataCompleto.novedadesCuentaDatos != undefined) {
            novedadLimiteDefectoTarjeta = props.dataCompleto.novedadesCuentaDatos.find(x => x.NovedadCampoCodigo == this.props.codigoNovedad);
            if (novedadLimiteDefectoTarjeta) {
                const esNovedadEditadaDescripcion = props.dataCompleto.esNovedadEditada.find(x => x.campoCodigo == this.props.codigoNovedad).editado;
                if (esNovedadEditadaDescripcion == false) {
                    descripcion = novedadLimiteDefectoTarjeta.ValorNovedad;
                }
            }
        }
        ////////////////////////////////////////////////////

        let componente = <div>
            <GenericInputValidate
                getFieldProps={getFieldProps('limiteDefectoTarjeta', {
                    onChange(e) {
                        me.changeInput(e);
                    },
                    rules: [{
                        required: true,
                        pattern: /^(?=.*[0-9])\d{0,2}(?:\.\d{0,1})$|^\d{0,2}(100)?$/,
                        message: 'Debe ingresar código válido.'
                    }]
                })}
                id="limiteDefectoTarjeta"
                name="limiteDefectoTarjeta"
                value={descripcion}
                className="form-control default-input"
                autoComplete="off"
            />
            {errorContainer}
        </div>

        let textPanel = "";
        if (descripcion) {
            textPanel = descripcion + "% del límite de la cuenta";
        } else {
            textPanel = "Sin especificar";
        }

        if (novedadLimiteDefectoTarjeta) {
            if (novedadLimiteDefectoTarjeta.ValorAnterior == "") {
                novedadLimiteDefectoTarjeta.ValorAnterior = "Sin especificar";
            }
        }

        return (
            <GenericEditPanel
                componente={componente}
                cuenta={props.data}
                error={(error || (descripcion == undefined || descripcion == ""))}
                novedad={novedadLimiteDefectoTarjeta}
                permisoUsuario={props.dataCompleto.funcionesDelUsuario}
                seEstaEditando={seEstaEditando}
                textPanel={textPanel || "Sin especificar"}
                title="Límite por defecto para cada tarjeta"
                value={descripcion}

                aceptChanges={(value) => this.props.guardarNovedad(value)}
                confirmarNovedad={() => this.actualizarNovedadEstado(novedadLimiteDefectoTarjeta, 2, props.data.CuentaTarjetaId)}
                changeEditMode={(value) => this.props.estadoEdicion(value, this.props.codigoNovedad)}
                denegarNovedad={() => this.actualizarNovedadEstado(novedadLimiteDefectoTarjeta, 3, props.data.CuentaTarjetaId)}
                mostrarModificaciones={this.props.mostrarModal}
                revert={this.props.cancelar} />
        );
    }
}

export default LimiteDefectoTarjeta;